
import { Box, Typography } from '@mui/material';
import { AccountBoxOutlined } from '@mui/icons-material';
import { ActionItemStatus } from '@uplift/api';
import { useCurrentuser } from '@uplift/contexts';
import { useL10n } from '@uplift/hooks';
import { useProviderDetailsQuery } from '@uplift/queries';
import { LightChip, LinkDashboardActionItem } from '@uplift/ui-v2';

import { getChipColor } from '../../helpers';
import { useSharedStyles } from '../../styles';

export type SetupMatchingProfileProps = {
  status: ActionItemStatus;
};

export const SetupMatchingProfile: React.VFC<SetupMatchingProfileProps> = ({ status }) => {
  const l10n = useL10n();
  const { classes: sharedClasses } = useSharedStyles();
  const user = useCurrentuser();
  const { data: profile, isLoading: profileIsLoading } = useProviderDetailsQuery(user?.id);

  if (profileIsLoading) {
    return null;
  }

  if (status === ActionItemStatus.todo) {
    return (
      <LinkDashboardActionItem
        title={l10n.dashboard.actionItems.setupMatchingProfile.title}
        body={l10n.dashboard.actionItems.setupMatchingProfile.subtitle}
        bodyClassName={sharedClasses.actionItemSubtitle}
        color="secondary"
        icon={<AccountBoxOutlined />}
        link="/profile"
        actionText={profile?.matchingProfileBookmark === 'initial' ? l10n.providerSettings.onboarding.createProfile : l10n.providerSettings.onboarding.continue}
      />
    );
  }

  return (
    <Box className={sharedClasses.progressSummaryStepWithChip}>
      <Box display="flex" flexDirection="column">
        <Typography variant="h5">{l10n.providerSettings.onboarding.matchingProfile}</Typography>
      </Box>
      <LightChip label={l10n.dashboard.actionItems.status[status]} color={getChipColor(status)} size="small" />
    </Box>
  );
};
